import { ApiErrorType } from "./../../enums";
/**
 * Note: we removed the show_important_hyperlinks_panel property from this object but not from the npm object.
 * Make sure to not include this when rewriting the npm package
 */
export interface Portal {
    /** The id of the portal */
    portal_id: number;
    /** The name of the portal */
    name: string;
    /** Permissions on manage news*/
    can_manage_news: boolean;
    /** Permissions on management information */
    may_see_diagrams: boolean;
    /** Shows the browse button*/
    show_browse_button: boolean;
    /** Has news items enable/disable news menu*/
    has_content_items: boolean;
    /** Enable/disable fill out menu */
    has_fillable_contents: boolean;
    /** Indicates if the portal has any diagrams coupled */
    has_diagrams: boolean;
    /** Indicates if the portal has any reports coupled */
    has_reports: boolean;
    /** Indicates if the portal should display link to report management module */
    show_link_to_reporting: boolean;
    /** Organization unit for this portal */
    organization_unit_id: number;
    /** When the user last visited (if ever) this portal*/
    last_visited_date_time: string | null;
    /** Important hyperlinks panel title */
    important_hyperlinks_panel_title: string | null;
    /**Group of the portal */
    portal_group: PortalGroup;
    /** If the user can see the ID's of the documents along with the title */
    show_identifier: boolean;
    /** Identifier setting type */
    show_identifier_setting_type: IdentifierSettingType;
    search_feedback_instruction: string;
    search_feedback_instruction_setting_type: SearchFeedbackInstructionSettingType;
    has_tooltip_fields: boolean;
    /** The color of the portal */
    color: string;
    /** The background image of the portal */
    background_image_base64: string;
    /** default selected collection   */
    selected_collection?: CollectionMini;
    /** default expanded collections */
    expanded_collections?: CollectionMini[];
    /** Panels of the portal */
    panels?: PortalPanel[];
}

export interface PortalPanel {
    /** The id of the panel */
    panel_id: number;
    /** The title of the panel */
    title?: string;
    /** Order of the panel */
    order: number;
    /** Type of panel */
    type: PortalPanelType;
    /** Items of the panel */
    items: PortalPanelItem[];
}

export enum PortalPanelType {
    /** News panel */
    News = "news_article",
    /** Importand documents panel */
    Documents = "important_links",
    /** Recent panel */
    Recent = "recent",
    /** Favorites panel */
    Favorites = "favorites",
    /** Information panel */
    Information = "information",
    /** Custom standard panel */
    Standard = "panel_with_text",
    /** Custom image panel */
    Icon = "panel_with_icons",
    /** Campaigns panel */
    Campaigns = "campaigns"
}

export interface PortalPanelItem {
    /** Text of the item */
    text?: string;
    /** Image/logo of the item */
    icon?: MaterialIcon;
    /** Reference id */
    reference_id?: string;
    /** Order of the item */
    order: number;
}

export interface MaterialIcon {
    /** The material icon name */
    name: string;
}

export interface CollectionMini {
    collection_id: number;
    name: string;
}
export interface PortalGroup {
    /** The id of the portal group*/
    portal_group_id: number;
    /** Name of the group  */
    name: string;
    /** Organization unit for this portal */
    order: number;
}
export declare enum IdentifierSettingType {
    /** Not modified by user*/
    Default = 0,
    /** Modified by user*/
    Custom = 1
}
export declare enum SearchFeedbackInstructionSettingType {
    /** Not modified by user*/
    Default = 0,
    /** Modified by user*/
    Custom = 1
}
export interface PortalSettings {
    /** If the user can see the ID's of the documents along with the title */
    show_identifier: boolean;
    /** The color of the portal */
    color: string;
    /** The background image of the portal */
    background_image_base64: string;
}

export interface PortalSearchOptions {
    text: string;
    scope: SearchScope;
}

export type SearchScope = "global" | "portal" | "ai";

export interface PortalResult {
    portal?: Portal;
    errorType?: ApiErrorType;
    showError: Boolean;
}

export interface PortalInformation {
    /** The id of the portal */

    portal_id: number;

    /** The title of the pannel */

    title: string;

    /** Base64 encoded image to be displayed */

    image: string;

    /** The text of the pannel information */

    text: string;

    /** The position of the image */

    image_position: number;

    /** The order of the image and text */

    display_text_first: boolean;
}
